var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#111116"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_2323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6367 8H13.6367C10.8757 8 8.63672 10.239 8.63672 13V19C8.63672 21.761 10.8757 24 13.6367 24H19.6367C22.3977 24 24.6367 21.761 24.6367 19V13C24.6367 10.239 22.3977 8 19.6367 8ZM23.1367 19C23.1367 20.93 21.5667 22.5 19.6367 22.5H13.6367C11.7067 22.5 10.1367 20.93 10.1367 19V13C10.1367 11.07 11.7067 9.5 13.6367 9.5H19.6367C21.5667 9.5 23.1367 11.07 23.1367 13V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6367 12C14.4277 12 12.6367 13.791 12.6367 16C12.6367 18.209 14.4277 20 16.6367 20C18.8457 20 20.6367 18.209 20.6367 16C20.6367 13.791 18.8457 12 16.6367 12ZM16.6367 18.5C15.2587 18.5 14.1367 17.378 14.1367 16C14.1367 14.621 15.2587 13.5 16.6367 13.5C18.0147 13.5 19.1367 14.621 19.1367 16C19.1367 17.378 18.0147 18.5 16.6367 18.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9353 12.234C21.2297 12.234 21.4683 11.9953 21.4683 11.701C21.4683 11.4066 21.2297 11.168 20.9353 11.168C20.641 11.168 20.4023 11.4066 20.4023 11.701C20.4023 11.9953 20.641 12.234 20.9353 12.234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_2323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.63672 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInsta);
export default __webpack_public_path__ + "static/media/ico-insta.b2910b9b78496d17e820bbef7701edf2.svg";
export { ForwardRef as ReactComponent };